export default __webpack_public_path__ + "static/media/ThinkCorporates.6d3522490337b89e845bfd9102837898.webp";